import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { visuallyHiddenStyle } from "sprout-ui-dom/dist/utils";
import { CheckOutlined as BaseCheckOutlined } from "sprout-ui-icons";
import { Flex } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import styled, { css } from "styled-components";
const width = [
    "34px",
    "45px"
];
const height = width;
const CheckOutlined = styled(BaseCheckOutlined)`
  opacity: 0;
  width: inherit;
  height: inherit;

  ${({ $completed  })=>$completed && css`
      opacity: 1;
    `}
`;
const PostPagePostCompletedLabel = styled(Flex)`
  flex: none;

  cursor: pointer;
  pointer-events: auto;
  ${({ $disabled  })=>$disabled ? css`
          cursor: not-allowed;
          pointer-events: none;
        ` : css`
          ${media.up("medium", "pointer")} {
            :hover ${CheckOutlined} {
              opacity: 1;
            }
          }
        `}
`;
const PostPagePostCompleted = (props)=>{
    const { id , completed , disabled , onChange  } = props;
    return /*#__PURE__*/ _jsxs(PostPagePostCompletedLabel, {
        display: "inline-flex",
        as: "label",
        $disabled: disabled,
        htmlFor: id,
        width: width,
        height: height,
        children: [
            /*#__PURE__*/ _jsx("input", {
                disabled: disabled,
                type: "checkbox",
                style: visuallyHiddenStyle,
                onChange: onChange,
                className: "mousetrap",
                checked: completed,
                id: id
            }),
            /*#__PURE__*/ _jsx(Flex, {
                m: "auto",
                as: "span",
                alignItems: "center",
                justifyContent: "center",
                width: width,
                height: height,
                color: completed ? "white.100" : "grey.600",
                borderWidth: completed ? undefined : "4px",
                bg: completed ? "#51c65b" : undefined,
                borderStyle: completed ? undefined : "solid",
                borderColor: completed ? undefined : disabled ? "black.16" : "grey.600",
                borderRadius: "50%",
                children: /*#__PURE__*/ _jsx(CheckOutlined, {
                    $completed: completed
                })
            })
        ]
    });
};
export default PostPagePostCompleted;
